import React, { useEffect, useRef, useState } from 'react';
import { Card, Table, Button, Alert, Space, Typography, Select, Popconfirm, Grid } from 'antd';
import { KeyOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons';

const { Title } = Typography;
const { Option } = Select;
const { useBreakpoint } = Grid;

const EfirmaTab = ({
  companies,
  efirmaRecords,
  selectedCompany,
  loading,
  onCompanySelect,
  onUpload,
  onDelete,
}) => {
  const [bottomPaginationVisible, setBottomPaginationVisible] = useState(false);
  const topPaginationRef = useRef(null);
  const screens = useBreakpoint();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setBottomPaginationVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );

    if (topPaginationRef.current) {
      observer.observe(topPaginationRef.current);
    }

    return () => observer.disconnect();
  }, [selectedCompany]);

  const columns = [
    {
      title: 'RFC',
      key: 'taxId',
      dataIndex: 'taxId',
      render: (v, r) => v || r.tax_id || r.rfc || '',
    },
    {
      title: 'Estado',
      key: 'active',
      dataIndex: 'active',
      render: (v) => (v === false ? 'Inactivo' : 'Activo'),
    },
    {
      title: 'Acciones',
      key: 'actions',
      render: () => (
        <Popconfirm
          title="¿Eliminar eFirma del proveedor?"
          description="Esto elimina la eFirma asociada al RFC en el proveedor."
          onConfirm={onDelete}
          okText="Sí"
          cancelText="No"
        >
          <Button type="link" danger icon={<DeleteOutlined />}>
            Eliminar
          </Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <Card>
      <div style={{ marginBottom: '16px' }}>
        <Title level={4} style={{ margin: 0, marginBottom: '16px' }}>
          eFirma (FIEL)
        </Title>

        <Space direction={screens.xs ? 'vertical' : 'horizontal'} style={{ marginBottom: '16px', width: screens.xs ? '100%' : 'auto' }}>
          <Select
            placeholder="Selecciona una empresa"
            style={{ width: screens.xs ? '100%' : 400 }}
            value={selectedCompany?.id}
            onChange={onCompanySelect}
          >
            {companies.map((company) => (
              <Option key={company.id} value={company.id}>
                {company.tax_name} - {company.tax_id}
              </Option>
            ))}
          </Select>

          <Button
            type="primary"
            icon={<UploadOutlined />}
            disabled={!selectedCompany}
            onClick={onUpload}
            block={screens.xs}
          >
            Subir eFirma
          </Button>
        </Space>
      </div>

      <Alert
        message="Información"
        description="La eFirma se usa para servicios SAT como descarga/gestión (no es el mismo certificado que el CSD para timbrar)."
        type="info"
        showIcon
        style={{ marginBottom: '16px' }}
        icon={<KeyOutlined />}
      />

      {selectedCompany && (
        <>
          <div ref={topPaginationRef} />
          <Table
            columns={columns}
            dataSource={efirmaRecords}
            rowKey={(r, idx) => r.id || r.taxId || String(idx)}
            loading={loading}
            locale={{ emptyText: 'No hay eFirma registrada para esta empresa' }}
            pagination={{
              position: bottomPaginationVisible ? ['topRight', 'bottomRight'] : ['topRight'],
            }}
            scroll={{ x: 'max-content' }}
          />
        </>
      )}

      {!selectedCompany && (
        <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
          Selecciona una empresa para gestionar su eFirma
        </div>
      )}
    </Card>
  );
};

export default EfirmaTab;

